import { render, staticRenderFns } from "./IndividualExamRecentAnswerSheetPage.vue?vue&type=template&id=436578ae&scoped=true"
import script from "./IndividualExamRecentAnswerSheetPage.vue?vue&type=script&lang=js"
export * from "./IndividualExamRecentAnswerSheetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436578ae",
  null
  
)

export default component.exports